import api from "./api";

export const DASHBOARD_PERIODS = [
  { value: "this_month", label: "This Month" },
  { value: "last_3_months", label: "Last 3 Months" },
  { value: "last_6_months", label: "Last 6 Months" },
  { value: "this_year", label: "This Year" },
];

export const DASHBOARD_BRANCHES = [
  { value: "all", label: "All Branches" },
  { value: "jakarta", label: "Jakarta" },
  { value: "surabaya", label: "Surabaya" },
  { value: "bali", label: "Bali" },
];

export async function getDashboardOverview({ period, branch, signal } = {}) {
  const { data } = await api.get("/dashboard/overview", {
    params: { period, branch },
    signal,
  });
  return data;
}
